import { ContentBox } from "@msuite/ui/app-shell";
import { DataTable } from "@msuite/ui/table";
import { useContacts } from "@/hooks/use-contacts";
import { ContactsMenu } from "./contacts-menu";
import { columns } from "./table-config";

export function Contacts() {
	/** Query */
	const { contacts, isLoading, queryKey, refetch } = useContacts();

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={contacts}
				columns={columns}
				isLoading={isLoading}
				queryKey={queryKey}
				menu={<ContactsMenu queryKey={queryKey} />}
				persistenceKey="clients-table"
				refetch={refetch}
				initialPinningState={{
					start: ["type"],
				}}
			/>
		</ContentBox>
	);
}
